import Call from '../../Call.v2';
import {objToQs} from '../../Utils';

const conversionsCutoff = {
    get(filters) {
        return Call(`peerclick/conversions/cutoff?${objToQs(filters)}`);
    },
    affids() {
        return Call(`peerclick/conversions/cutoff/affids`);
    },
    subids(filters) {
        return Call(`peerclick/conversions/cutoff/subids?${objToQs(filters)}`);
    },
    getAll() {
        return Call(`peerclick/conversions/cutoff`);
    },
    create({ affid, subid, country, cutoff }) {
        return Call(`peerclick/conversions/cutoff`, "POST", { affid, subid, country, cutoff });
    },
    update(id, data) {
        return Call(`peerclick/conversions/cutoff/${id}`, "PUT", data);
    },
    delete(id) {
        return Call(`peerclick/conversions/cutoff/${id}`, "DELETE");
    },
};

export default conversionsCutoff;



// WEBPACK FOOTER //
// ./src/services/API/components/peerclick/conversions-cutoff.js